import $ from "cash-dom";
window.$ = $

// import notchDetect from 'notch-detected-event'
// console.log("hjhjh", notchDetect)

window.isMobile = function() {
    return window.innerHeight > window.innerWidth && 'ontouchstart' in document.documentElement
}()

import jump from 'jump.js'
window.jump = function(el, options={}) {
    const duration = 'duration' in options ? options.duration : 1000
    console.log(el, isMobile)
    jump(el, {
        offset: -($('header').height() - 1),
        duration: duration,
        container: isMobile ? 'main#home' : window,
        callback: options.callback || null
    })
}

window.shopifyInitialized = false

// require('./vendor/buy-button-storefront.js');
// require('./vendor/notch-detected-event.js');

// Navigation
require('./navigation.js')

// Consent
require('./consent.js')